import React from 'react'
import { Card } from '@mui/material'
import { styled } from '@mui/material/styles'
import { ImageIcon } from '@/icon'
import bell from '@/asset/img/bell.webp'

export const NotificationCard = styled(Card)(() => ({
  width: '396px',
  background: '#FFFCF4',
  boxShadow: '0px 6px 20px 0px rgba(4,27,15,0.1)',
  borderRadius: '4px',
  border: '1px solid #FFE599',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
}))

export const Row = styled('div')(() => ({
  width: '100%',
  display: 'flex',
}))

export const NotificationIcon = () => (
  <ImageIcon src={bell} sx={{ width: '22px', position: 'relative' }} />
)
